import { GET_ORGS } from "../actions/types";

const initialState = {
  orgs: [],

  loading: false
};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_ORGS:
      return {
        ...state,
        orgs: action.payload,
        loading: false
      };

    default:
      return state;
  }
}
